import React from 'react';

import IconButton from '../../../common2/IconButton';

import RotateLeftIcon from '../../../../icons/rotate-left.svg';
import RotateRightIcon from '../../../../icons/rotate-right.svg';
import ZoomInIcon from '../../../../icons/zoom-in.svg';
import ZoomOutIcon from '../../../../icons/zoom-out.svg';

import styles from './DocumentsImageControls.scss';
import { Action, Direction, maxZoomLevel, minZoomLevel } from './useImageControls';

type Props = {
  rotate: (direction: Direction) => void;
  zoom: (action: Action) => void;
  zoomLevel: number;
};

function DocumentsImageControls(props: Props) {
  const { rotate, zoom, zoomLevel } = props;

  return (
    <div className={styles.container}>
      <div className={styles.buttonGroup}>
        <IconButton icon={RotateLeftIcon} ariaLabel="Turn left" disabled={false} onClick={() => rotate('left')} />
        <IconButton icon={RotateRightIcon} ariaLabel="Turn right" disabled={false} onClick={() => rotate('right')} />
      </div>
      <div className={styles.buttonGroup}>
        <IconButton
          icon={ZoomOutIcon}
          disabled={zoomLevel === minZoomLevel}
          ariaLabel="Zoom Out"
          onClick={() => zoom('out')}
        />
        <IconButton
          icon={ZoomInIcon}
          disabled={zoomLevel === maxZoomLevel}
          ariaLabel="Zoom In"
          onClick={() => zoom('in')}
        />
      </div>
    </div>
  );
}

export default React.memo(DocumentsImageControls);
